// Import directly from the core implementation to avoid circular deps
import { defineStore } from 'pinia'
import { defaultParams } from '@/utils/constants'

export const useContentStore = defineStore('content', {
  state: () => ({
    title: '',
    id: null,
    content: '',
    showTitle: true,
    meta: '',
  }),

  actions: {
    setContent(content) {
      this.title = content.name
      this.id = content.id
      this.meta = content.meta
      this.content = content.content
      this.showTitle = !content.features?.hideH1
    },

    async getContent(contentId, options = {}) {
      const { rootStore = null, $axios = null, error = null } = options

      // Handle global loading/error states if rootStore is provided
      if (rootStore) {
        rootStore.removeError('content')
        rootStore.addLoading('content')
      }

      // Get axios from nuxt context if not provided
      const axiosInstance = $axios || (process.client && window.$nuxt ? window.$nuxt.$axios : null)

      if (!axiosInstance) {
        if (rootStore) {
          rootStore.addError({ id: 'content', error: new Error('No axios instance') })
          rootStore.removeLoading('content')
        }
        return
      }

      try {
        const response = await axiosInstance.get(`/content/${contentId}`, { params: defaultParams })
        const { data: content } = response.data

        this.setContent(content)
      } catch (err) {
        if (err.response?.status === 404 && error) {
          error({ statusCode: 404, message: 'Content not found' })
        }

        if (rootStore) {
          rootStore.addError({ id: 'content', error: err })
        }
      } finally {
        if (rootStore) {
          rootStore.removeLoading('content')
        }
      }
    },
  },
})
